var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VApp',{},[_c('AppHeader'),_c('NotificationBar',{attrs:{"data-cy":"notificationBar"}}),_c('VMain',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('RouterView')],1)],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }